export default __webpack_public_path__ + "static/media/snark-light-roast.5ea0fc3b.png";